export default __webpack_public_path__ + "static/media/baixou-declarou-passeou.3f6f8d13.png";